import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import { computed, watch, ref, reactive } from 'vue';
import { getVexTableProps } from '@/config';
import { getGroupActivityMerchandiseList } from '@/request';
export default {
  name: 'merchandise-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    branchId: [String, Number],
    supplierIds: [String, Number],
    selectedList: {
      type: Array,
      default: () => []
    },
    checkType: {
      type: String,
      default: 'checkbox'
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        form.prodName = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const form = reactive({
      prodName: ''
    });
    const tableTotal = ref(0);
    const tableOptions = computed(() => {
      const type = props.checkType;
      return getVexTableProps({
        columns: [{
          type,
          width: '50px'
        }, {
          title: '发货方',
          field: 'branchName'
        }, {
          title: '药品编码',
          field: 'prodNo'
        }, {
          title: '药品名称',
          field: 'prodName'
        }, {
          title: '药品规格',
          field: 'prodSpecification'
        }, {
          title: '单位',
          field: 'packageUnit',
          width: '80px'
        }],
        pagerConfig: {
          currentPage: 1,
          pageSize: 10000
        },
        proxyConfig: {
          ajax: {
            query: ({
              page
            }) => new Promise(res => {
              const params = _objectSpread({
                page: page.currentPage,
                pageSize: page.pageSize,
                branchIds: props.branchId,
                supplierIds: props.supplierIds
              }, form);

              getGroupActivityMerchandiseList(params).then(data => {
                tableTotal.value = data.data.totalSize;
                const activityMerchandiseList = data.data.activityMerchandiseList || [];
                res({
                  total: data.data.totalSize,
                  result: activityMerchandiseList
                });

                if (props.selectedList.length > 0 && props.checkType === 'checkbox') {
                  setTimeout(() => {
                    const selectedRows = activityMerchandiseList.filter(item => props.selectedList.find(v => v === item.prodNo));
                    table.value.setCheckboxRow(selectedRows, true);
                  }, 300);
                }
              });
            })
          }
        }
      });
    });

    function submit() {
      let selectRows = [];

      if (props.checkType === 'checkbox') {
        selectRows = table.value.getCheckboxRecords();
      } else {
        selectRows = [table.value.getRadioRecord()];
      }

      visible.value = false;
      emit('success', selectRows);
    }

    function resetHandle() {
      form.prodName = undefined;
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_pager = _resolveComponent("vxe-pager");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择商品",
        width: "80%",
        top: "5vh",
        "modal-class": "package-formula-merchandise-modal"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "药品名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.prodName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.prodName = $event),
              placeholder: "请输入药品名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Refresh",
              onClick: resetHandle
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          maxHeight: "600"
        }), {
          pager: _withCtx(() => [_createVNode(_component_vxe_pager, {
            layouts: ['Total'],
            total: tableTotal.value
          }, null, 8, ["total"])]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};